import { Injectable, Optional, Pipe, PipeTransform } from '@angular/core';
import { LANG } from 'src/app/models/enums/lang.enum';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'localizeTime',
	pure: false,
})
@Injectable({
	providedIn: 'root',
})
export class LocalizeTimePipe implements PipeTransform {
	constructor(
		@Optional() private util?: UtilService,
		@Optional() private translate?: TranslateService
	) {}

	transform(value: string, lang?: string): string {
		const currentLang = lang || this.util?.currentLang || this.translate?.currentLang || LANG.KM;
		return this.formatTimeTo12Hour(value, currentLang);
	}

	formatTimeTo12Hour(time: string, lang: string = LANG.KM): string {
		if (!time) return '';

		const isPM = /pm|ថ្ងៃ/i.test(time);
		const isAM = /am|ព្រឹក/i.test(time);

		const cleanTime = time.replace(/[^\d:]/g, '');
		const parts = cleanTime.split(':');
		let hour = parseInt(parts[0], 10);
		const minute = parseInt(parts[1], 10);

		if (isNaN(hour) || isNaN(minute)) return time;

		const isAfternoon = isPM || (!isAM && hour >= 12);

		let period = '';
		if (lang === LANG.EN) {
			period = isAfternoon ? 'PM' : 'AM';
		} else {
			period = isAfternoon ? 'ថ្ងៃ' : 'ព្រឹក';
		}

		if (!isPM && !isAM) {
			if (hour === 0) {
				hour = 12;
			} else if (hour > 12) {
				hour -= 12;
			}
		} else {
			if (hour === 0) {
				hour = 12;
			}
		}

		const formattedHour = hour.toString().padStart(2, '0');
		const formattedMinute = minute.toString().padStart(2, '0');

		return `${formattedHour}:${formattedMinute} ${period}`;
	}
}
